import {createRoot} from 'react-dom/client';
import '@prtimes-basis/styles/reset.css';
import '@prtimes-basis/styles/global.css';
import {Layout} from '@/features/company-registration/components/layout';
import {CompanyRegistrationPage} from '@/features/company-registration/company-registration-page';
import {ToastProvider} from '@/hooks/use-toast';

const container = document.querySelector('#root');
if (container !== null)
  createRoot(container).render(
    <Layout>
      <ToastProvider>
        <CompanyRegistrationPage />
      </ToastProvider>
    </Layout>,
  );
